export default __webpack_public_path__ + "static/star_trek_online_div-04f1adb1e99bbf3d7147912c55ca0f1c.avif";